import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  TextInput, required, ReferenceArrayInput, AutocompleteArrayInput, ReferenceArrayField, SingleFieldList, ChipField, BooleanInput, BooleanField, ReferenceField, FormDataConsumer, Show,
} from "react-admin";
import EditView from "../../../components/EditView";
import CreateView from "../../../components/CreateView";


export const SendSMSList = (props) => (

  <List {...props} sort={{ field: 'updatedAt', order: 'DESC' }}>
    <Datagrid rowClick="show" sort={{ field: 'order', order: 'ASC' }}>
      <BooleanField source="sendToAll" label="ارسال به همه" />
      <TextField source="content" label="متن پیام"  rows={5} validate={required()} />
      <ReferenceField label="ساخته شده توسط" source="owner" link={null} reference="adminUsers" >
        <TextField source="name" />
      </ReferenceField>
      <DateField locales={"fa-IR"} source="createdAt" />

    </Datagrid>
  </List>
);

export const SendSMSEdit = (props) => (
  <EditView {...props} perPage={10}>
    <BooleanInput source="sendToAll" label="ارسال به همه" />

    <ReferenceArrayInput source="users" label="همکاران" reference="adminUsers">
      {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
      <AutocompleteArrayInput source="name" optionText="name" />
    </ReferenceArrayInput >
    <TextInput source="content" label="متن پیام" multiline rows={5} validate={required()} />

  </EditView>
);

export const SendSMSShow = (props) => (
  <Show {...props} actions={null}>
    <SimpleShowLayout>
      <BooleanField source="sendToAll" label="ارسال به همه" />

      <TextField source="content" label="متن پیام" />
      <ReferenceArrayField label="همکاران" source="users" reference="adminUsers" >
        <SingleFieldList linkType={null}>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
    </SimpleShowLayout>
  </Show>
);

export const SendSMSCreate = (props) => (
  <CreateView {...props}>
    <BooleanInput source="sendToAll" label="ارسال به همه" />
    <FormDataConsumer>
      {({ formData, ...rest }) => !formData.sendToAll && <div>

        <ReferenceArrayInput source="users" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput variant="outlined" source="name" optionText="name" />
        </ReferenceArrayInput >
      </div>
      }
    </FormDataConsumer>
    <TextInput source="content" label="متن پیام"
    inputProps={{
      maxLength: 100,
    }}
    multiline rows={5} validate={required()} />
  </CreateView>
);
